// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9f1c45d7","455":"b18d05de","977":"4dc656c1"}[chunkId] + ".chunk.js";
};